import { Component, OnInit, ViewChild } from '@angular/core';

import { Client } from '../../shared/client.model';

import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  ToastController,
  IonInput
} from '@ionic/angular';
import { Product } from '../../shared/product.model';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { OrderResponse } from '../../shared/orderResponse.model';
import { BnplService } from 'src/app/service/bnpl.service';
import { Fua } from 'src/app/shared/fua.model';
import { DetailBnpl } from 'src/app/shared/detailBnpl.model';
import { Constant } from "../../shared/model/Constant";
import { AdminService } from 'src/app/service/admin.service';
import { ClientResponse } from 'src/app/shared/clientResponse.model';
import { QueryBalance } from 'src/app/shared/queryBalance.model';
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: 'app-balance',
  templateUrl: './balance.page.html',
  styleUrls: ['./balance.page.scss'],
})
export class BalancePage implements OnInit {
  @ViewChild('fieldFocus', { static: false }) fieldFocus!: IonInput;

  documents: any;
  typeDoc: number;
  typeDocCode: number;
  document: string;
  phone: number;
  email: string;
  clientId: number;
  entityId: number;
  formDisabled: boolean = false;
  informationId: number;
  validEmail: boolean = true;
  validPhone: boolean = true;
  typeSend: string = "no";
  showConfirm: boolean;
  message: string = "";
  titleCard: string = "";
  detailMessage: string = "";
  showRecommendation: boolean = false;
  showImg: boolean = false;
  showModalBnplInfo: boolean = false;
  query: QueryBalance;
  ipClient: string = "127.0.0.1";
  showEndTrx: boolean = false;
  titleEnd: string = "Hola.";
  detailCard: string = "";
  messageEnd: string = "Tienes un monto disponible para usarlo en la forma de pago Compra y Paga Después.";
  imgEnd: string = "endBnpl";
  cupoClient: string;
  secondName: string;
  firstName: string;
  firstLastName: string;
  secondLastName: string;
  client: Client;
  formGroup!: FormGroup;

  constructor(public modalController: ModalController,
    public alertController: AlertController,
    public toastController: ToastController,
    private nav: NavController,
    private adminService: AdminService,
    private authService: AuthService,
    private bnplService: BnplService,
    private builder: FormBuilder,
    public loadingController: LoadingController, private router: Router) {
  }




  addDescount() {
  }


  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 2500,
      position: 'top',
      mode: 'ios',
      color: 'primary'
    });
    toast.present();
  }



  ngOnInit() {
    this.getToken();
    this.bnplService.getIp().subscribe((res: any) => {
      this.ipClient = res.IPv4;
      this.queryBalance();
    }, error => {
      this.bnplService.getIp1().subscribe((res: any) => {
        console.log(res);
        this.ipClient = res.ip;
        this.queryBalance();
      }, error => {
        console.warn('Error fua no ip 2', error);
      });
    });

    this.adminService.getTypeIdentificationId().subscribe((res: any) => {
      this.documents = res;
    });

  }

  queryBalance() {
    this.query = JSON.parse(localStorage.getItem(Constant.balance));
    if (this.query && this.query.code) {
      var requestBalance = {
        "authCode": this.query.code,
        "idInformaciongeneral": this.query.informationId,
        "idUsuario": Constant.systemUser,
        "ip": this.ipClient,
      };
      this.bnplService.queryBalanceBnpl(requestBalance).subscribe((res: any) => {
        this.titleEnd = "Hola!";
        this.messageEnd = "Tienes un monto disponible para usarlo en la forma de pago Compra y Paga Después.";
        this.cupoClient = res.cupo;
        this.showEndTrx = true;
        localStorage.removeItem(Constant.balance);
      }, error => {
        localStorage.removeItem(Constant.balance);
        this.presentToast('No se encuentra el proveedor disponible, por favor vuelva a consultar su saldo.');
      });
    } else {
      localStorage.removeItem(Constant.balance);
    }
  }

  typeDocumentChange(ev: any) {
    var valueTypeDoc = ev.target.value;
    this.typeDocCode = valueTypeDoc.code;
    this.typeDoc = valueTypeDoc.typeIdentificationId;
    this.document = null;
    this.clearClient();

  }

  searchClient() {
    if (!this.typeDoc) {
      this.presentToast('Debe seleccionar un tipo de identificación para buscar el cliente.');
      return;
    }

    this.authService.getClientByDocument(this.document).subscribe((res: ClientResponse) => {
      if (res) {
        if (this.typeDoc === res.identificationTypeId) {
          this.phone = res.celular;
          this.email = res.mail;
          this.firstName = res.firstName;
          this.firstLastName = res.firstLastName;
          this.secondName = res.secondName;
          this.secondLastName = res.secondLastName;
          this.entityId = res.entityId;
          this.informationId = res.informationId;
          this.formDisabled = true;
        } else {
          this.clearClient();
          this.presentToast('No se encontro el cliente, por favor complete los datos para continuar.');
        }
      } else {
        this.clearClient();
        this.presentToast('No se encontró el cliente, por favor complete los datos para continuar.');
      }
      this.fieldFocus.setFocus();
    }, error => {
      console.warn('Error consulta cliente ', error);
      this.clearClient();
      this.presentToast('No se encuentra cliente con este documento, valida los datos por favor.');
      this.fieldFocus.setFocus();
    });
  }

  validatePhone() {
    setTimeout(() => {
      if (this.phone && this.phone.toString().length === 10) {
        this.validPhone = true;
      } else {
        this.validPhone = false;
      }
    }, 0);
  }

  validateOnlyNumbers() {

    if (this.document) {
      this.document = String(this.document).replace(/\D/g, '');
    }
    if (this.phone) {
      this.phone = Number(String(this.phone).replace(/\D/g, ''));
    }
  }

  validateOnlyLetters() {
    if (this.firstName) {
      this.firstName = String(this.firstName).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
    if (this.firstLastName) {
      this.firstLastName = String(this.firstLastName).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
    if (this.secondName) {
      this.secondName = String(this.secondName).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
    if (this.secondLastName) {
      this.secondLastName = String(this.secondLastName).replace(/[^a-zA-Z ]/g, '').substring(0, 20);
    }
  }

  validateMail() {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
      this.validEmail = true;
    } else {
      this.validEmail = false;
    }
  }

  clearClient() {
    this.phone = null;
    this.email = null;
    this.firstName = null;
    this.firstLastName = null;
    this.secondLastName = null;
    this.secondName = null;
    this.entityId = null;
    this.informationId = null;
    this.formDisabled = false;
  }

  checkTypeSend(tipo: string) {
    console.warn('tipo selected ', tipo);
    this.typeSend = tipo;
  }

  async openModalDescrptProduct() {
    if (!this.entityId && (!this.typeDoc || !this.document
      || !this.firstName
      || !this.firstLastName
      || !this.phone || !this.email)
    ) {
      this.presentToast('Disculpanos pero debes adicionar los datos del cliente para continuar y crearlo.');
      return;
    }

    if (this.typeSend === 'no') {
      this.presentToast('Disculpanos pero debes aceptar el tratamiento de datos para poder continuar.');
      return;
    }
    if (!this.entityId) {
      this.client = new Client();
      this.client.firstName = this.firstName;
      this.client.identificationTypeId = this.typeDoc;
      this.client.firstLastName = this.firstLastName;
      this.client.secondName = this.secondName;
      this.client.secondLastName = this.secondLastName;
      this.client.document = this.document;
      this.client.celular = this.phone;
      this.client.whatsapp = this.phone;
      this.client.mail = this.email;
      this.client.registeredBy = Constant.systemUser.toString();
      this.authService.addClient(this.client).subscribe((res: ClientResponse) => {
        this.entityId = res.entityId;
        this.informationId = res.informationId;
        this.sendTerminos();
      }, error => {
        console.warn('Error consulta cliente ', error);
        this.clearClient();
        this.presentToast('Se encontró un error al crear el cliente verifica los datos e intenta de nuevo.');
        this.fieldFocus.setFocus();
      });
    } else {
      this.sendTerminos();
    }



  }

  async sendTerminos() {
    const loading = await this.loadingController.create({
      message: 'Consultando..',
      spinner: 'bubbles',
      duration: 100000
    });
    await loading.present();
    var requestAcceptance = {
      "idClient": Constant.systemUser,
      "idEntidad": this.entityId
    };
    this.authService.acceptanceDeclarations(requestAcceptance).subscribe((res: any) => {
      if (res) {
        //Consultamos el prospecto
        var requestProspect = {
          "idInformaciongeneral": this.informationId,
          "idUsuario": Constant.systemUser,
          "documentType": this.typeDocCode,
          "documentNumber": this.document

        };
        this.bnplService.validateProspectBnpl(requestProspect).subscribe((res: any) => {
          if (res && res.activo) {
            this.showConfirm = false;
            this.showConfirm = true;
          } else {
            this.titleCard = "Te Recomendamos";
            this.detailCard = "Revisa si tienes obligaciones de pago y ponte al día. Tambien valida que tu capacidad de pago no sobrepase el 30% de tus ingresos";
            this.showRecommendation = false;
            this.showImg = true;
            this.message = "Lo sentimos"
            this.detailMessage = "En este momento no estas habilitado para finalizar este proceso con Compra y Paga Después."
            this.showModalBnplInfo = true;
          }
          loading.dismiss();
        }, error => {
          this.presentToast('No se encuentra el proveedor disponible.');
          loading.dismiss();
        });
      } else {
        loading.dismiss();
        this.presentToast('No logramos almacenar la aceptación.');
      }
    }, error => {
      loading.dismiss();
      this.presentToast('	No se logró almacenar la aceptación.');
    });
  }

  closePage() {
    window.open('', '_parent', '');
    window.close();
  }

  close() {
    this.showConfirm = false;
  }

  async sendFuaBnpl() {
    const loading = await this.loadingController.create({
      message: 'Redireccionando a Bancolombia..',
      spinner: 'bubbles',
      duration: 100000
    });
    await loading.present();
    this.query = new QueryBalance();
    this.query.typeFua = Constant.typeFuaQR;
    this.query.document = Number(this.document);
    this.query.typeDocument = this.typeDoc;
    this.query.idClient = this.clientId;
    this.query.informationId = this.informationId;
    localStorage.setItem(Constant.balance, JSON.stringify(this.query));

    var requestFua = {
      "authenticationMode": Constant.typeFuaPN,
      "idOrden": null,
      "ip": this.ipClient,
      "idClient": this.query.idClient

    };
    this.bnplService.sendTrxFuaBnpl(requestFua).subscribe((res: Fua) => {
      if (res.url === null) {
        this.presentToast('El proveedor no responde, intente mas tarde por favor.');
        loading.dismiss();
        return;
      }
      window.location.href = res.url;
      loading.dismiss();
    }, error => {
      console.warn('Error fua autenticacion ', error);
      this.presentToast('No se encuentra el proveedor disponible.');
      loading.dismiss();
    });
  }


  showPoints() {
    window.location.href = "https://location-bnpl.yopresto.co/";
  }



  onWillDismissEndTrx(modalEvent: Event) {

  }

  onWillDismissConfirm(modalEvent: Event) {

  }

  onWillDismissMethod(event: Event) {

  }

  refresh(orderBnpl: OrderResponse, orderDetailBnpl: DetailBnpl, router: Router) {

  }

  getToken() {
    let data = {
      document: 9999999,                
      password: 'X%fq8$*Q_M3A9fai4AcEdkL2K5Pa$3'
    };
    this.authService.login(data).subscribe((res: any) => {
      localStorage.setItem(Constant.token, res.token);
    }, error => {
      // console.log("No funciono");
    });
  }

}
